import { RootState } from '@/store/stores'
import {
  ActionCreatorWithPreparedPayload,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import _, { add, size } from 'lodash'
import controllerApi from '@/api/operations/controllerApi'
import {
  Controller,
  SearchController,
  SubInterface,
  initialState,
} from './types'
import interfaceApi from '@/api/admin/interfaceApi'

/**
 * Actions
 */

export const fetchController = createAsyncThunk(
  'diagnostic/fetchController',
  async (params: SearchController, { rejectWithValue }) => {
    try {
      const { data } = await controllerApi.getAll(params)

      return data as Controller[]
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchSubInterfaces = createAsyncThunk(
  'diagnostic/fetchSubInterfaces',
  async (interfaceId: number, { rejectWithValue }) => {
    try {
      const { data } = await controllerApi.getSubInterface(interfaceId)
      const enrichedData = await Promise.all(
        data.map(async (item: SubInterface) => {
          try {
            const res = await interfaceApi.getById(item.interfaceId + '')
            return {
              ...item,
              interfaceDetail: res.data,
            }
          } catch (err) {
            return {
              ...item,
              interfaceDetail: null,
            }
          }
        }),
      )
      return enrichedData as SubInterface[]
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const diagnosticSlice = createSlice({
  name: 'diagnostic',
  initialState,
  reducers: {
    setSubInterface: (state, action) => {
      state.selectedSubInterface = action.payload
    },
  },
  extraReducers: (builder) => {
    builder

      //fetchController
      .addCase(fetchController.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchController.fulfilled,
        (state, action: PayloadAction<Controller[]>) => {
          state.loading = false
          state.controllers = action.payload
        },
      )
      .addCase(fetchController.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      //fetchSubInterfaces
      .addCase(fetchSubInterfaces.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchSubInterfaces.fulfilled,
        (state, action: PayloadAction<SubInterface[]>) => {
          state.loading = false
          state.subInterfaces = action.payload
        },
      )
      .addCase(fetchSubInterfaces.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setSubInterface } = diagnosticSlice.actions

export const diagnosticState = (state: RootState) => state.diagnostic

export default diagnosticSlice.reducer
